import { StorageKeys } from "@utils/enums";
import { attemptMethod } from "@utils/general";
import { scrollToPosition } from "@utils/scroll";

type ScrollPositionsStorageModel = Record<string, number | undefined>;

const getScrollPositions = () => {
    const storageValue = sessionStorage.getItem(StorageKeys.ScrollPosition);
    if (!storageValue) return {};

    return attemptMethod<ScrollPositionsStorageModel>(
        () => JSON.parse(storageValue),
        {},
    );
};

const popScrollPosition = (location: string) => {
    const scrollPositions = getScrollPositions();

    setScrollPositions({
        ...scrollPositions,
        [location]: undefined,
    });

    return scrollPositions[location];
};

const setScrollPositions = (scrollPositions: ScrollPositionsStorageModel) => {
    sessionStorage.setItem(
        StorageKeys.ScrollPosition,
        JSON.stringify(scrollPositions),
    );
};

export const pushPosition = (position: number, location: string) => {
    const scrollPositions = getScrollPositions();

    setScrollPositions({
        ...scrollPositions,
        [location]: position,
    });
};

export const scrollToLastPosition = () => {
    const lastScrollPosition = popScrollPosition(window.location.href);
    if (!lastScrollPosition) return;

    setTimeout(() => {
        scrollToPosition(lastScrollPosition);
    }, 100);
};
